<div class="card">
  <div class="card-body">
    <div class="mb-0">
      <div class="mb-2">
        <div class="row modal-content border border-dark ml-0 mb-4 p-0 search-order-overview">
          <div class="col col-md-12">
            <div class="order-header">
              <div class="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3 pt-2">
                <button class="btn-link-back" (click)="goBack()">
                  <i class="mdi mdi-arrow-left"></i>
                  <span>Quay về danh sách</span>
                </button>
                <button
                  class="btn btn-primary btn-sm d-flex align-items-center gap-2"
                  (click)="onUpdate(data, handleOrder)"
                >
                  <i class="mdi mdi-lightning-bolt-outline"></i>
                  <span>Thao tác đơn hàng</span>
                </button>
              </div>
            </div>
            <div class="info-card">
              <div class="info-card-header">
                <span>{{ "Thông tin cửa hàng" | translate }}</span>
              </div>
              <div class="shop-identity d-flex align-items-center gap-3 flex-wrap">
                <div class="shop-icon-circle flex-shrink-0">
                  <img
                    src="../../../assets/images/store.png"
                    class="img-fluid"
                    alt="image"
                  />
                </div>
                <div class="d-flex align-items-center flex-wrap gap-2">
                  <span class="order-code">#{{ data.workspace_code }}</span>
                  <h2 class="order-name mb-0">
                    {{ data.workspace_name | translate }}
                  </h2>
                </div>
              </div>
              <div class="detail-list detail-list--inline">
                <div class="detail-list-item">
                  <i class="mdi mdi-barcode-scan"></i>
                  <div>
                    <span class="info-label">Terminal ID</span>
                    <span class="info-value">{{ data.terminalID || "Chưa có" }}</span>
                  </div>
                </div>
                <div class="detail-list-item">
                  <i class="mdi mdi-account-outline"></i>
                  <div>
                    <span class="info-label">Thông tin khách hàng</span>
                    <span class="info-value">{{ data.user_phone }} - {{ data.full_name }}</span>
                  </div>
                </div>
                <div class="detail-list-item">
                  <i class="mdi mdi-bank-outline"></i>
                  <div>
                    <span class="info-label">Thông tin tài khoản</span>
                    <span class="info-value">
                      {{ data.terminal_bank_acc || "Chưa có" }}
                      <ng-container *ngIf="data.terminal_bank_acc_name">
                        - {{ data.terminal_bank_acc_name }}
                      </ng-container>
                    </span>
                  </div>
                </div>
                <div class="detail-list-item">
                  <i class="mdi mdi-domain"></i>
                  <div>
                    <span class="info-label">Loại cửa hàng</span>
                    <span
                      class="badge font-size-12"
                      [ngClass]="getCustomerTypeClass(data.customer_type)"
                    >
                      {{ getCustomerTypeLabel(data.customer_type) }}
                    </span>
                  </div>
                </div>
                <div class="detail-list-item">
                  <i class="mdi mdi-calendar-check-outline"></i>
                  <div>
                    <span class="info-label">Ngày tạo</span>
                    <span class="info-value">
                      {{ data.workspace_created_at | date : "dd/MM/yyyy" }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="detail-row">
              <div class="info-card">
                <div class="info-card-header">
                  <i class="mdi mdi-speaker"></i>
                  <span>Thông tin đơn hàng</span>
                </div>
                <div class="d-flex gap-3 align-items-start flex-wrap">
                  <div class="product-icon flex-shrink-0">
                    <i
                      class="mdi"
                      [ngClass]="{
                        'mdi-signal-cellular-3': data.device_name === 'Loa 4G',
                        'mdi-wifi': data.device_name === 'Loa WIFI',
                        'mdi-speaker-wireless':
                          data.device_name !== 'Loa 4G' &&
                          data.device_name !== 'Loa WIFI'
                      }"
                    ></i>
                  </div>
                  <div class="flex-grow-1 product-info">
                    <h3 class="product-name">
                      {{ serviceTypeMap[data.service_package_type] || "Đơn thường" }}
                    </h3>
                    <div class="product-badges d-flex flex-wrap align-items-center gap-2">
                      <span
                        class="badge font-size-12"
                        [ngClass]="{
                          'badge-info': data.device_name === 'Loa 4G',
                          'badge-primary': data.device_name === 'Loa WIFI',
                          'badge-dark': data.device_name === 'Loa 4G+WIFI',
                          'badge-secondary':
                            data.device_name !== 'Loa 4G' &&
                            data.device_name !== 'Loa WIFI' &&
                            data.device_name !== 'Loa 4G+WIFI'
                        }"
                      >
                        {{ data.device_name || "--" }} x {{ data.quantity || 1 }}
                      </span>
                      <span
                        class="badge font-size-12"
                        *ngIf="data.original_duration"
                        [ngClass]="{
                          'badge-secondary': data.original_duration == 3,
                          'badge-info': data.original_duration == 6,
                          'badge-warning': data.original_duration == 12,
                          'badge-success': data.original_duration == 60,
                          'badge-dark':
                            data.original_duration != 3 &&
                            data.original_duration != 6 &&
                            data.original_duration != 12 &&
                            data.original_duration != 60
                        }"
                      >
                        Gói {{ data.original_duration }} tháng
                      </span>
                      <span class="product-code" *ngIf="data.referrer">
                        <i class="mdi mdi-pound"></i>Mã giới thiệu: {{ data.referrer }}
                      </span>
                    </div>
                    <div class="product-benefit" *ngIf="data.benefit">
                      <i class="mdi mdi-shield-check-outline"></i>
                      {{ data.benefit }}
                    </div>
                  </div>
                  <div class="price-block flex-shrink-0 ms-auto text-end">
                    <p
                      class="price-original"
                      *ngIf="data.original_price && data.original_price !== data.discounted_price"
                    >
                      {{ data.original_price | number : "1.0-0" }}<sup>đ</sup>
                    </p>
                    <p class="price-discounted">
                      {{ data.discounted_price | number : "1.0-0" }}<sup>đ</sup>
                    </p>
                    <span class="discount-pill" *ngIf="getDiscountPercent() > 0">
                      -{{ getDiscountPercent() }}%
                    </span>
                  </div>
                </div>
                <div class="order-extra-info d-flex flex-wrap gap-4">
                  <span class="meta-item">
                    <i class="mdi mdi-calendar-arrow-right"></i>
                    Ngày mua:
                    <b>{{ data.created_at | date : "dd/MM/yyyy HH:mm" }}</b>
                  </span>
                  <span class="meta-item">
                    <i class="mdi mdi-headset"></i>
                    CSKH: <b>{{ getCsTakeCare(data) }}</b>
                  </span>
                </div>
                <div class="order-extra-info d-flex flex-wrap gap-4">
                  <span class="meta-item" *ngIf="data.activation_date">
                    <i class="mdi mdi-calendar-check-outline"></i>
                    Ngày kích hoạt: <b>{{ data.activation_date | date : "dd/MM/yyyy" }}</b>
                  </span>
                  <span class="meta-item" *ngIf="data.expiration_date">
                    <i class="mdi mdi-calendar-clock"></i>
                    Ngày hết hạn: <b>{{ data.expiration_date | date : "dd/MM/yyyy" }}</b>
                  </span>
                </div>
                <!-- <div class="transaction-box" *ngIf="data.mb_reference_number">
                  <span>Mã giao dịch: <b>{{ data.mb_reference_number }}</b></span>
                  <button
                    [cdkCopyToClipboard]="data.mb_reference_number"
                    class="btn btn-sm btn-primary"
                  >
                    <i class="mdi mdi-content-copy"></i>
                  </button>
                </div> -->
                <div
                  class="cancel-request-info"
                  *ngIf="data.oc_requested_cancel_date || data.oc_reason"
                >
                  <div
                    class="meta-item"
                    *ngIf="data.oc_requested_cancel_date"
                  >
                    <i class="mdi mdi-calendar-remove-outline"></i>
                    Ngày yêu cầu hủy:
                    <b>
                      {{ data.oc_requested_cancel_date | date : "dd/MM/yyyy" }}
                    </b>
                  </div>
                  <div class="meta-item" *ngIf="data.oc_reason">
                    <i class="mdi mdi-alert-circle-outline"></i>
                    Lý do hủy: <b>{{ data.oc_reason }}</b>
                  </div>
                </div>
                <div class="rm-info-box" *ngIf="data?.rm_info">
                  <div class="rm-info-line" *ngIf="buildRmInfoLine(data?.rm_info)">
                    RM: <b>{{ buildRmInfoLine(data?.rm_info) }}</b>
                  </div>
                  <div class="rm-agency-line" *ngIf="buildRmAgencyLine(data?.rm_info)">
                    {{ buildRmAgencyLine(data?.rm_info) }}
                  </div>
                </div>
              </div>
              <div class="info-card">
                <div class="info-card-header d-flex justify-content-between align-items-center flex-wrap gap-2">
                  <span>
                    <i class="mdi mdi-map-marker-outline"></i>
                    {{ "Thông tin giao hàng" | translate }}
                  </span>
                  <button
                    *ngIf="data.delivery_method == 'shipper'"
                    class="btn btn-outline-primary btn-sm"
                    (click)="onDetailHistory(data, detailOrder)"
                  >
                    Chi tiết giao hàng
                  </button>
                </div>
                <div class="detail-list detail-list--row">
                  <div class="detail-list-item">
                    <i class="mdi mdi-check-circle-outline"></i>
                    <div>
                      <span class="info-label">Trạng thái: </span>
                      <span
                        class="info-value status-text"
                        [ngClass]="orderStatusClass(data.status)"
                      >
                        {{ data.status }}
                      </span>
                    </div>
                  </div>
                  <div class="detail-list-item">
                    <i class="mdi mdi-map-marker-outline"></i>
                    <div>
                      <span class="info-label">Địa chỉ: </span>
                      <span class="info-value" *ngIf="data.delivery_method == 'shipper'">
                        {{ buildShipperAddress(data) || "Chưa có" }}
                      </span>
                      <span class="info-value" *ngIf="data.delivery_method == 'direct'">
                        {{ buildDirectAddress(data) || "Chưa có" }}
                      </span>
                    </div>
                  </div>
                  <div class="detail-list-item">
                    <i class="mdi mdi-account-outline"></i>
                    <div>
                      <span class="info-label">Người nhận: </span>
                      <span class="info-value" *ngIf="data.delivery_method == 'shipper'">
                        {{ data.customer_name }}
                      </span>
                      <span class="info-value" *ngIf="data.delivery_method == 'direct'">
                        {{ data.full_name }}
                      </span>
                    </div>
                  </div>
                  <div class="detail-list-item">
                    <i class="mdi mdi-phone-outline"></i>
                    <div>
                      <span class="info-label">Số điện thoại: </span>
                      <span class="info-value" *ngIf="data.delivery_method == 'shipper'">
                        {{ formatPhoneDisplay(data.phone) }}
                      </span>
                      <span class="info-value" *ngIf="data.delivery_method == 'direct'">
                        {{ formatPhoneDisplay(data.user_phone) }}
                      </span>
                    </div>
                  </div>
                  <div
                    class="detail-list-item"
                    *ngIf="data.delivery_method == 'shipper' && data.order_code"
                  >
                    <i class="mdi mdi-barcode"></i>
                    <div>
                      <span class="info-label">Mã vận đơn: </span>
                      <span class="info-value">{{ data.order_code }}</span>
                    </div>
                  </div>
                  <div
                    class="detail-list-item"
                    *ngIf="data.delivery_method == 'shipper' && data.ghn_sent_date"
                  >
                    <i class="mdi mdi-send-outline"></i>
                    <div>
                      <span class="info-label">Ngày gửi ĐVVC: </span>
                      <span class="info-value">{{ data.ghn_sent_date }}</span>
                    </div>
                  </div>
                  <div
                    class="detail-list-item"
                    *ngIf="data.delivery_method == 'shipper' && data.delivery_date"
                  >
                    <i class="mdi mdi-package-variant-closed"></i>
                    <div>
                      <span class="info-label">Ngày giao thành công: </span>
                      <span class="info-value">{{ data.delivery_date }}</span>
                    </div>
                  </div>
                </div>
                <div class="mini-stats" *ngIf="data.delivery_method == 'shipper'">
                  <div class="mini-stat">
                    <p class="mini-stat-label">Đơn vị giao hàng</p>
                    <p class="mini-stat-value">{{ data.shipping_unit }}</p>
                  </div>
                  <div class="mini-stat">
                    <p class="mini-stat-label">Thời gian dự kiến</p>
                    <p class="mini-stat-value">
                      {{ data.expected_delivery_time || "Chưa có" }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="search-order-table-card">
          <div class="info-card-header info-card-header--bar">
            <i class="mdi mdi-speaker-multiple"></i>
            <span>Danh sách thiết bị</span>
          </div>
          <div class="table-responsive">
            <table
              id="basic-datatable"
              class="table table-bordered dt-responsive nowrap no-footer dtr-inline table-modern"
            >
              <thead>
                <tr class="text-center bg-table">
                  <th>{{ "#" | translate }}</th>
                  <th>{{ "Mã thiết bị" | translate }}</th>
                  <th>{{ "Model" | translate }}</th>
                  <th>{{ "Nhà mạng" | translate }}</th>
                  <th>{{ "Mã sim" | translate }}</th>
                  <th>{{ "Trạng thái" | translate }}</th>
                  <th>{{ "Kết nối" | translate }}</th>
                  <th>{{ "Ngày kích hoạt" | translate }}</th>
                  <th>{{ "Ngày hết hạn" | translate }}</th>
                  <th>{{ "Ngày gia hạn gần nhất" | translate }}</th>
                  <th>{{ "Quản lý" | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  class="text-center"
                  *ngFor="let data2 of listDataDevice; let i = index"
                >
                  <td>{{ pageSize * (pageIndex - 1) + i + 1 }}</td>

                  <td>
                    <button type="button" class="btn btn-link p-0" (click)="onRenewHistory(data2, renewHistory)">
                      {{ data2.serial_number }}
                    </button>
                  </td>
                  <td>{{ data2.model }}</td>
                  <td>{{ data2.network_provider }}</td>
                  <td>{{ data2.sim4g_imsi }}</td>
                  <td>
                    <span
                      class="status-pill status-pill--sm"
                      [ngClass]="{
                        'status-pill--danger': data2.status === 'Inactive',
                        'status-pill--success': data2.status === 'Active',
                        'status-pill--secondary': data2.status === 'Expired'
                      }"
                    >
                      {{ data2.status }}
                    </span>
                  </td>
                  <td>
                    <span
                      class="status-pill status-pill--sm"
                      [ngClass]="{
                        'status-pill--danger': data2.connectedStatus === 'Disconnected',
                        'status-pill--success': data2.connectedStatus === 'Connected'
                      }"
                    >
                      {{ data2.connectedStatus }}
                    </span>
                  </td>
                  <td>{{ data2.activation_date | date : "dd/MM/yyyy" }}</td>
                  <td>{{ data2.expiration_date | date : "dd/MM/yyyy" }}</td>
                  <td>{{ data2.last_renewal_date | date : "dd/MM/yyyy" }}</td>
                  <td>
                    <div class="d-flex justify-content-around">
                      <button
                        class="btn btn-sm btn-outline-warning"
                        (click)="onEdit(data2, contentQR)"
                      >
                        Lấy mã QR
                      </button>
                      <button
                        class="btn btn-sm btn-outline-primary"
                        (click)="onChange(data2, contentLink)"
                      >
                        Gửi thông báo
                      </button>
                      <button
                        class="btn btn-sm btn-outline-success"
                        (click)="onEdit(data2, contentSearch)"
                      >
                        Tra cứu giao dịch
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="search-order-table-card">
          <div class="info-card-header info-card-header--bar">
            <i class="mdi mdi-history"></i>
            <span>Lịch sử test thông báo</span>
          </div>
          <div class="table-responsive">
            <table
              id="basic-datatable"
              class="table table-bordered dt-responsive nowrap no-footer dtr-inline table-modern"
            >
              <thead>
                <tr class="text-center bg-table">
                  <th>{{ "#" | translate }}</th>
                  <th>{{ "Người tác động" | translate }}</th>
                  <th>{{ "Mã thiết bị" | translate }}</th>
                  <th>{{ "Số tiền" | translate }}</th>
                  <th>{{ "Thao tác" | translate }}</th>
                  <th>{{ "Trạng thái" | translate }}</th>
                  <th>{{ "Thời gian" | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  class="text-center"
                  *ngFor="let data2 of listDataLog; let i = index"
                >
                  <td>{{ pageSize * (pageIndex - 1) + i + 1 }}</td>
                  <td>{{ data2.full_name }}</td>
                  <td>{{ data2.serial_number }}</td>
                  <td>{{ data2.amount }}</td>
                  <td>{{ "Gửi thông báo" }}</td>
                  <td>
                    {{ data2.status === 1 ? "Thành công" : "Thất bại" }}
                  </td>
                  <td>{{ data2.created_at }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #changeToOnline role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">
      {{ "Thay đổi luồng giao hàng sang Online" | translate }}
    </h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form (ngSubmit)="onChangeShip()" [formGroup]="formData">
        <div class="row">
          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">{{
              "Tên người nhận" | translate
            }}</label>
            <div class="col-md-10">
              <input
                type="text"
                class="form-control"
                formControlName="recipient_name"
                [ngClass]="{
                  'is-invalid': submitted && form.recipient_name.errors
                }"
              />
            </div>
          </div>
          <!-- <div class="form-group row col-md-12">
              <label class="col-5 col-form-label required_label"
                >{{'Phương thức' | translate}}</label
              >
              <div class="col-12">
                <select
                  class="form-select"
                  aria-label="Default select example"
                  class="form-control"
                  formControlName="delivery_method"
                  [ngClass]="{'is-invalid': submitted && form.delivery_method.errors}"
                >
                  <option value="{{item.value}}"
                    >{{item.label}}
                  </option>
                </select>
              </div>
            </div> -->
          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">{{
              "Số điện thoại" | translate
            }}</label>
            <div class="col-md-10">
              <input
                type="phone"
                class="form-control"
                formControlName="phone_number"
                [ngClass]="{
                  'is-invalid': submitted && form.phone_number.errors
                }"
              />
            </div>
          </div>

          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">{{
              "Thành phố/Tỉnh" | translate
            }}</label>
            <div class="col-md-10">
              <ng-select
                [items]="listProvince"
                bindLabel="PROVINCE_NAME"
                (change)="onProvinceChange($event)"
                formControlName="province"
                placeholder="{{ 'Chọn thành phố/tỉnh' | translate }}"
                [ngClass]="{ 'is-invalid': submitted && form.province.errors }"
              >
              </ng-select>
            </div>
          </div>

          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">{{
              "Quận/Huyện" | translate
            }}</label>
            <div class="col-md-10">
              <ng-select
                [items]="listDistrict"
                bindLabel="DISTRICT_NAME"
                (change)="onDistrictChange($event)"
                formControlName="district"
                placeholder="{{ 'Chọn quận/huyện' | translate }}"
                [ngClass]="{ 'is-invalid': submitted && form.district.errors }"
              >
              </ng-select>
            </div>
          </div>

          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">{{
              "Phường/Xã" | translate
            }}</label>
            <div class="col-md-10">
              <ng-select
                [items]="listWard"
                bindLabel="WARDS_NAME"
                formControlName="ward"
                placeholder="{{ 'Chọn phường/xã' | translate }}"
                [ngClass]="{ 'is-invalid': submitted && form.ward.errors }"
              >
              </ng-select>
            </div>
          </div>

          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">{{
              "Địa chỉ cụ thể" | translate
            }}</label>
            <div class="col-md-10">
              <input
                type="text"
                class="form-control"
                formControlName="specific_address"
                [ngClass]="{
                  'is-invalid': submitted && form.specific_address.errors
                }"
              />
            </div>
          </div>
        </div>

        <div class="text-center">
          <button
            type="button"
            class="btn btn-secondary btn-lg mr-3"
            style="width: 150px"
            (click)="modal('close click')"
          >
            {{ "Đóng" | translate }}
          </button>
          <button
            type="submit"
            class="btn btn-success btn-lg"
            style="width: 150px"
          >
            {{ "Cập nhật" | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #contentLink role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Gửi thông báo tới thiết bị</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form (ngSubmit)="deviceCheck()" [formGroup]="formData">
        <div class="row">
          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">{{
              "Thiết bị" | translate
            }}</label>
            <div class="col-md-10">
              <input
                disabled
                type="text"
                class="form-control"
                formControlName="serial_number"
                [ngClass]="{
                  'is-invalid': submitted && form.serial_number.errors
                }"
              />
            </div>
          </div>
          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">{{
              "Số tiền" | translate
            }}</label>
            <div class="col-md-10">
              <input
                placeholder="Nhập số tiền"
                type="number"
                class="form-control"
                formControlName="serial_number_new"
                [ngClass]="{
                  'is-invalid': submitted && form.serial_number_new.errors
                }"
              />
            </div>
          </div>
        </div>
        <div class="text-center">
          <button
            type="button"
            class="btn btn-secondary btn-lg mr-3"
            style="width: 150px"
            (click)="modal('close click')"
          >
            {{ "Đóng" | translate }}
          </button>
          <button
            type="submit"
            class="btn btn-success btn-lg"
            style="width: 150px"
          >
            {{ "Gửi thông báo" | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #updatecontent role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Cập nhật cuộc gọi</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form (ngSubmit)="updateOrder()" [formGroup]="formData">
        <div class="row">
          <div class="form-group row col-md-12">
            <label class="col-5 col-form-label required_label">{{
              "Hành động" | translate
            }}</label>
            <div class="col-12">
              <select
                class="form-select"
                aria-label="Default select example"
                class="form-control"
                formControlName="typeUpdate"
                [ngClass]="{
                  'is-invalid': submitted && form.typeUpdate.errors
                }"
              >
                <option value="{{ item.value }}" *ngFor="let item of typePhone">
                  {{ item.label }}
                </option>
              </select>
            </div>
          </div>
          <div class="form-group row col-md-12">
            <label class="col-md-5 col-form-label required_label">{{
              "Ghi chú" | translate
            }}</label>
            <div class="col-md-12">
              <textarea
                placeholder="Nhập ghi chú"
                class="form-control"
                formControlName="note"
                [ngClass]="{ 'is-invalid': submitted && form.note.errors }"
                rows="3"
              ></textarea>
            </div>
          </div>
        </div>
        <div class="text-center">
          <button
            type="button"
            class="btn btn-secondary btn-lg mr-3"
            style="width: 150px"
            (click)="modal('close click')"
          >
            {{ "Đóng" | translate }}
          </button>
          <button
            type="submit"
            class="btn btn-primary btn-lg"
            style="width: 150px"
          >
            {{ "Cập nhật" | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #contentSearch role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Tra cứu giao dịch</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form [formGroup]="formData">
        <div class="row">
          <div class="form-group row col-md-12">
            <div class="col-md-6">
              <label class="col-md-12 col-form-label required_label">{{
                "Mã Thiết Bị" | translate
              }}</label>
              <div class="col-md-10 mt-4">
                <input
                  disabled
                  type="text"
                  class="form-control"
                  formControlName="serial_number"
                  [ngClass]="{
                    'is-invalid': submitted && form.serial_number.errors
                  }"
                />
              </div>
            </div>
            <div class="col-md-6">
              <label class="col-md-12 col-form-label required_label">{{
                "Khoảng thời gian" | translate
              }}</label>
              <div class="col-md-10">
                <div class="form-group col-3">
                  <mat-form-field appearance="fill" class="mt-3">
                    <mat-label>Chọn khoảng ngày </mat-label>
                    <mat-date-range-input
                      [formGroup]="range"
                      [rangePicker]="picker"
                    >
                      <input
                        matStartDate
                        formControlName="start"
                        [min]="minTransactionDate"
                        placeholder="Ngày bắt đầu"
                      />
                      <input
                        matEndDate
                        formControlName="end"
                        [min]="minTransactionDate"
                        placeholder="Ngày kết thúc"
                      />
                    </mat-date-range-input>
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="picker"
                    ></mat-datepicker-toggle>
                    <mat-date-range-picker #picker></mat-date-range-picker>
                    <mat-error
                      *ngIf="
                        range.controls.start.hasError('matStartDateInvalid')
                      "
                      >Invalid start date</mat-error
                    >
                    <mat-error
                      *ngIf="range.controls.end.hasError('matEndDateInvalid')"
                      >Invalid end date</mat-error
                    >
                  </mat-form-field>
                </div>
                <p class="text-danger font-size-10 font-italic">
                  Chọn khoảng thời gian để tra cứu
                </p>
                <button class="btn btn-success" (click)="getDataTransaction()">
                  Tra cứu
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="table-responsive">
          <table
            id="basic-datatable"
            class="table table-bordered dt-responsive nowrap no-footer dtr-inline"
          >
            <thead>
              <tr class="text-center bg-table">
                <th>{{ "#" | translate }}</th>
                <th *ngIf="role === 'admin'">{{ "Cửa hàng" | translate }}</th>
                <th>{{ "Mã giao dịch" | translate }}</th>
                <th>{{ "Thiết bị" | translate }}</th>
                <th>{{ "Số tài khoản" | translate }}</th>
                <th>{{ "Số tiền" | translate }}</th>
                <th>{{ "Trạng thái" | translate }}</th>
                <th>{{ "Ngày giao dịch" | translate }}</th>
              </tr>
            </thead>
            <tbody *ngFor="let data of dataTransaction; let i = index">
              <tr>
                <td>
                  <a>{{ pageSize * (pageIndex - 1) + i + 1 }}</a>
                </td>
                <td *ngIf="role === 'admin'">
                  <a>{{ data?.workspace_name }}</a>
                </td>
                <td>
                  <a>{{ data?.code }}</a>
                </td>
                <td>
                  <a>{{ data?.serial_number }}</a>
                </td>
                <td>
                  <a> {{ data.account_number }} </a>
                </td>

                <td>
                  <a>
                    {{ data?.total | number : "1.0-0" }} <sup><ins>đ</ins></sup>
                  </a>
                </td>

                <td>
                  <span
                    class="font-size-12 badge badge-danger"
                    *ngIf="data.status == '0'"
                    >{{ "Từ chối" | translate }}</span
                  >
                  <span
                    class="font-size-12 badge badge-warning"
                    *ngIf="data.status == '2'"
                    >{{ "Đang xử lý" | translate }}</span
                  >
                  <span
                    class="font-size-12 badge badge-success"
                    *ngIf="data.status == '1'"
                    >{{ "Đã thanh toán" | translate }}</span
                  >
                </td>
                <td>
                  <a>{{ data.created_at | date : "dd/MM/yyyy HH:mm" }}</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="row justify-content-md-between align-items-md-center mt-2">
          <div class="col-sm-12 col-md-5">
            <div
              class="dataTables_info mb-2"
              id="tickets-table_info"
              role="status"
              aria-live="polite"
            >
              {{ "TABLE.Showing" | translate }}
              {{ pageSize * pageIndex - pageSize + 1 }}
              {{ "TABLE.to" | translate }} {{ pageSize * pageIndex }}
              {{ "TABLE.of" | translate }} {{ totalCount }}
              {{ "TABLE.entries" | translate }}
            </div>
          </div>
          <!-- Pagination -->
          <div
            class="col-sm-12 col-md-5 d-flex align-items-center justify-content-end"
          >
            <div class="text-md-right float-md-right pagination-rounded">
              <ngb-pagination
                [collectionSize]="totalCount"
                [(page)]="pageIndex"
                [pageSize]="pageSize"
                [maxSize]="5"
                [ellipses]="true"
                (pageChange)="getDataTransaction()"
              >
              </ngb-pagination>
            </div>
            <div class="dataTables_length ml-3" id="tickets-table_length">
              <label class="d-inline-flex align-items-center mb-0">
                {{ "TABLE.Show" | translate }}
                <select
                  name="tickets-table_length"
                  aria-controls="tickets-table"
                  name="pageSize"
                  [(ngModel)]="pageSize"
                  (ngModelChange)="pageIndex = 1; fetchData()"
                  class="custom-select custom-select-sm form-control form-control-sm mx-2"
                >
                  <option [ngValue]="10">10</option>
                  <option [ngValue]="25">25</option>
                  <option [ngValue]="50">50</option>
                  <option [ngValue]="100">100</option>
                </select>
                {{ "TABLE.entries" | translate }}
              </label>
            </div>
          </div>
        </div>
        <div class="text-center">
          <button
            type="button"
            class="btn btn-secondary btn-lg mr-3"
            style="width: 150px"
            (click)="modal('close click')"
          >
            {{ "Đóng" | translate }}
          </button>
          <!-- <button
              type="submit"
              class="btn btn-success btn-lg"
              style="width: 150px;"
            >
              {{'Lưu' | translate}}
            </button> -->
          <!-- <button type="button" class="btn btn-secondary btn-sm" style="width: 150px"
                          (click)="modal('close click')">{{'FORM.Close' | translate}}</button>
                      <button type="button" class="btn btn-primary btn-sm ml-3" style="width: 150px"
                          (click)="updateFormNote()">{{'FORM.Save' | translate}}</button> -->
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #detailOrder role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Chi tiết vận chuyển đơn hàng</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="table-responsive">
    <table
      id="basic-datatable"
      class="table table-bordered dt-responsive nowrap no-footer dtr-inline"
    >
      <thead>
        <tr class="text-center bg-table">
          <th>{{ "#" | translate }}</th>
          <!-- <th>{{'Mã đơn' | translate}}</th> -->
          <th>{{ "Địa điểm" | translate }}</th>
          <th>{{ "Trạng thái" | translate }}</th>
          <th>{{ "Thời gian" | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          class="text-center"
          *ngFor="let data2 of dataHistory; let i = index"
        >
          <td>{{ pageSize * (pageIndex - 1) + i + 1 }}</td>
          <td>
            {{ data2.ware_house ? data2.ware_house : data2.localion_currently }}
          </td>
          <td>{{ data2.status ? data2.status : data2.status_name }}</td>
          <td>
            {{ data2.created_at ? data2.created_at : data2.order_statusdate }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-template>

<ng-template #transactionHistory role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">10 giao dịch gần đây</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="table-responsive">
    <table
      id="basic-datatable"
      class="table table-bordered dt-responsive nowrap no-footer dtr-inline"
    >
      <thead>
        <tr class="text-center bg-table">
          <th>{{ "#" | translate }}</th>
          <th *ngIf="role === 'admin'">{{ "Cửa hàng" | translate }}</th>
          <th>{{ "Mã giao dịch" | translate }}</th>
          <th>{{ "Thiết bị" | translate }}</th>
          <th>{{ "Số tài khoản" | translate }}</th>
          <th>{{ "Số tiền" | translate }}</th>
          <th>{{ "Trạng thái" | translate }}</th>
          <th>{{ "Ngày giao dịch" | translate }}</th>
        </tr>
      </thead>
      <tbody *ngFor="let data of dataTransaction; let i = index">
        <tr>
          <td>
            <a>{{ pageSize * (pageIndex - 1) + i + 1 }}</a>
          </td>
          <td *ngIf="role === 'admin'">
            <a>{{ data?.workspace_name }}</a>
          </td>
          <td>
            <a>{{ data?.code }}</a>
          </td>
          <td>
            <a>{{ data?.serial_number }}</a>
          </td>
          <td>
            <a> {{ data.account_number }} </a>
          </td>

          <td>
            <a>
              {{ data?.total | number : "1.0-0" }} <sup><ins>đ</ins></sup>
            </a>
          </td>

          <td>
            <span
              class="font-size-12 badge badge-danger"
              *ngIf="data.status == '0'"
              >{{ "Từ chối" | translate }}</span
            >
            <span
              class="font-size-12 badge badge-warning"
              *ngIf="data.status == '2'"
              >{{ "Đang xử lý" | translate }}</span
            >
            <span
              class="font-size-12 badge badge-success"
              *ngIf="data.status == '1'"
              >{{ "Đã thanh toán" | translate }}</span
            >
          </td>
          <td>
            <a>{{ data.created_at | date : "dd/MM/yyyy HH:mm" }}</a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-template>

<ng-template #contentQR role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Hiển thị QR</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form [formGroup]="formData">
        <div class="row">
          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">{{
              "Serial" | translate
            }}</label>
            <div class="col-md-10">
              <input
                disabled
                type="text"
                class="form-control"
                formControlName="serial_number"
                [ngClass]="{
                  'is-invalid': submitted && form.serial_number.errors
                }"
              />
            </div>
          </div>
          <div class="form-group row col-md-12">
            <div class="col-md-12 d-block justify-content-center">
              <div class="d-flex justify-content-center">
                <div
                  class="borderQR d-flex flex-column align-items-center"
                  *ngIf="flagDownQr"
                  #qrContainer
                >
                  <div class="qr-with-text canvas-container">
                    <qr-code
                      class="custom-qr-code"
                      [value]="qrCodeValue"
                      [size]="400"
                      [errorCorrectionLevel]="'M'"
                    >
                    </qr-code>
                    <div class="text-center user-info" *ngIf="flagDownQr">
                      <h3 class="">
                        {{ data.terminal_bank_acc_name }}
                      </h3>
                      <h3 class="">
                        {{ data.terminal_bank_acc }}
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-center mt-3">
                <div class="col-12 col-md-3 p-0">
                  <button class="btn-viettel col" (click)="downloadQRCode()">
                    <span class="m-auto">Tải xuống mã QR</span>
                  </button>
                  <button class="btn-viettel col mt-2" (click)="printQRCode()">
                    In QR Code
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="text-center">
          <button
            type="button"
            class="btn btn-secondary btn-lg mr-3"
            style="width: 150px"
            (click)="modal('close click')"
          >
            {{ "Đóng" | translate }}
          </button>
          <!-- <button
            type="submit"
            class="btn btn-success btn-lg"
            style="width: 150px;"
          >
            {{'Lưu' | translate}}
          </button> -->
          <!-- <button type="button" class="btn btn-secondary btn-sm" style="width: 150px"
                        (click)="modal('close click')">{{'FORM.Close' | translate}}</button>
                    <button type="button" class="btn btn-primary btn-sm ml-3" style="width: 150px"
                        (click)="updateFormNote()">{{'FORM.Save' | translate}}</button> -->
        </div>
      </form>
    </div>
  </div>
</ng-template>
<ng-template #handleOrder role="document" let-modal="close">
  <div class="modal-body">
    <p class="fw-bold mb-3">Chọn thao tác</p>
    <ul class="list-group">
      <!-- Delivery role -->
      <li
        *ngIf="!data.cs_take_care.lenght"
        class="list-group-item list-group-item-action"
        (click)="onChangeCSKH(data)"
      >
      <i class="mdi mdi-headset mr-2"></i>   Cập nhật CSKH hỗ trợ
      </li>
    </ul>
  </div>
</ng-template>

<ng-template #renewHistory role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Lịch sử đăng ký gói dịch vụ</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="table-responsive p-4 package-history-modal">
    <div class="package-history mt-2">
      <div
        *ngFor="let item of packageHistory"
        class="package-history-item"
        (click)="selectedPackageHistory = item"
        [ngClass]="{
          'active-border':
            item?.device_sub_renew_id == selectedPackageHistory?.device_sub_renew_id
        }"
      >
        <div class="d-flex justify-content-between">
          <div>
            <div class="package-info">
              <div class="package registered">
                <span class="dot"></span>
                <span class="text-package">Gói đăng ký: </span
                ><span class="info">{{ item?.original_duration }} tháng</span>
              </div>
              <div class="time-range">
                {{ item?.activation_date }} - {{ item?.registeredEnd }}
              </div>
            </div>

            <div *ngIf="item?.bonus_months" class="package-info">
              <div class="package gifted">
                <span class="dot"></span>
                <span class="text-package">Thời gian tặng thêm: </span
                ><span class="info">{{ item?.bonus_months }} tháng</span>
              </div>
              <div class="time-range">
                {{ item?.giftedStart }} - {{ item?.expiration_date }}
              </div>
            </div>
          </div>
          <div>
            <span
              *ngIf="item?.status == 'Pending'"
              class="badge badge-danger"
            >
              <i class="bi bi-circle-fill" style="font-size: 8px"></i> Mới đăng
              kí
            </span>
            <span
              *ngIf="item?.status == 'Active'"
              class="badge badge-success"
            >
              <i class="bi bi-circle-fill" style="font-size: 8px"></i> Đang sử
              dụng
            </span>
            <span
              *ngIf="item?.status == 'Expired'"
              class="badge badge-secondary"
            >
              <i class="bi bi-circle-fill" style="font-size: 8px"></i> Hết hạn
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="!packageHistoryLoading && packageHistory.length === 0" class="text-center p-3 text-muted">
    Chưa có dữ liệu
  </div>
</ng-template>
